module.exports = __webpack_public_path__ + "img/meal-icon-lunch.108897a9.svg";